import {
    GET_CUSTOMER_INFO_REQUEST,
    GET_CUSTOMER_INFO_SUCCESS,
    GET_CUSTOMER_INFO_FAILURE,
    GET_AGGREGATE_OPTIONS_LIST_REQUEST,
    GET_AGGREGATE_OPTIONS_LIST_SUCCESS,
    GET_AGGREGATE_OPTIONS_LIST_FAILURE,
    GET_CUSTOMER_SUMMARY_REQUEST,
    GET_CUSTOMER_SUMMARY_SUCCESS,
    GET_CUSTOMER_SUMMARY_FAILURE,
    POST_AGGREGATE_OPTIONS_REQUEST,
    POST_AGGREGATE_OPTIONS_SUCCESS
} from '../constants/';

const INIT_STATE = {
    isLoading: false,
    isInitialFetch: true,
    data: undefined,
    countryList: [],
    error: null,
    account: {},
    admin: {},
    message: undefined,
    aggregateOptions: [],
    accountSummary: []
}

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case GET_CUSTOMER_INFO_REQUEST:
            return {
                ...state,
                isLoading: true,
                error: null,
            };
        case GET_CUSTOMER_INFO_SUCCESS:
            return {
                ...state,
                isLoading: false,
                data: action.payload.customerInfo,
                isInitialFetch: false,
            };
        case GET_CUSTOMER_INFO_FAILURE:
            return {
                ...state,
                isLoading: false,
                error: action.payload.error.stack,
            };
        case GET_AGGREGATE_OPTIONS_LIST_REQUEST:
            return {
                ...state,
                isLoading: true,
                error: null,
            };

        case GET_AGGREGATE_OPTIONS_LIST_SUCCESS:
            return {
                ...state,
                isLoading: false,
                aggregateOptions: action.payload.aggregateOptions,
                isInitialFetch: false,
            };
        case GET_AGGREGATE_OPTIONS_LIST_FAILURE:
            return {
                ...state,
                isLoading: false,
                error: action.payload.error.stack,
            };
        case POST_AGGREGATE_OPTIONS_REQUEST:
            return {
                ...state,
                error: null,
            };
        case POST_AGGREGATE_OPTIONS_SUCCESS:
            return {
                ...state,
                selectedAggregateType: action.payload.aggregateOptions,
                message: null,
                error: null,
                isLoading: true
            };
        case GET_CUSTOMER_SUMMARY_REQUEST:
            return {
                ...state,
                isLoading: true,
                error: null,
            };
        case GET_CUSTOMER_SUMMARY_SUCCESS:
            return {
                ...state,
                isLoading: false,
                accountSummary: action.payload.accountSummary,
                isInitialFetch: false,
            };
        case GET_CUSTOMER_SUMMARY_FAILURE:
            return {
                ...state,
                isLoading: false,
                error: action.payload.error.stack,
            };
        default:
            return state;
    }
};